/**
 * Shared filters for the global header job search. State is shared between
 * the header filter button and the suggested-jobs list on /app/cv.
 */
export function useJobFilters() {
  const open = useState('job-filters-open', () => false)
  const type = useState<string>('job-filters-type', () => '')
  const mode = useState<string>('job-filters-mode', () => '')
  const salaryMin = useState<number | null>('job-filters-salary-min', () => null)
  const countryId = useState<number | null>('job-filters-country-id', () => null)
  const stateId = useState<number | null>('job-filters-state-id', () => null)
  const cityId = useState<number | null>('job-filters-city-id', () => null)

  const activeCount = computed(() => {
    let n = 0
    if (type.value) n++
    if (mode.value) n++
    if (salaryMin.value != null && salaryMin.value > 0) n++
    if (countryId.value != null) n++
    if (stateId.value != null) n++
    if (cityId.value != null) n++
    return n
  })

  function openSheet() {
    open.value = true
  }

  function closeSheet() {
    open.value = false
  }

  function reset() {
    type.value = ''
    mode.value = ''
    salaryMin.value = null
    countryId.value = null
    stateId.value = null
    cityId.value = null
  }

  return { open, type, mode, salaryMin, countryId, stateId, cityId, activeCount, openSheet, closeSheet, reset }
}
